import type { IContextMutationResult } from '@modules/core/services/query/types';
import { useRestClient } from '@modules/core/services/api';
import { useContextMutation } from '@modules/core/services/query';

import {
  AFFILIATE_PROFILE_RESET_TWO_FACTOR_AUTH_API_URL,
  AFFILIATE_PROFILE_RESET_TWO_FACTOR_AUTH_MUTATION,
  AFFILIATES_APPROVED_PROFILE_PERMISSIONS,
} from '../constants';

export default function useAffiliateProfileResetTwoFactorAuthMutation(): IContextMutationResult<void, Error, number> {
  const { fetchPost } = useRestClient();

  return useContextMutation<void, Error, number>({
    mutationKey: [AFFILIATE_PROFILE_RESET_TWO_FACTOR_AUTH_MUTATION],
    mutationFn: (id) => fetchPost<void>(
      AFFILIATE_PROFILE_RESET_TWO_FACTOR_AUTH_API_URL,
      null,
      {
        permission: AFFILIATES_APPROVED_PROFILE_PERMISSIONS.CLEAR_GOOGLE_SECRET,
        urlParams: {
          id,
        },
      },
    ),
  });
}
